import { main } from 'jsonlint-mod';
import { DirectionalLight, SpotLight,RectAreaLight, PointLight, HemisphereLight, AmbientLight } from 'three';

function createLights() {
  // const ambientLight = new HemisphereLight(
  //   'white',
  //   'darkslategrey',
  //   4,
  // );

  // const mainLight = new DirectionalLight('white', 2.5);
  // mainLight.position.set(5, 3, 20);

  // const behindLight = new DirectionalLight('white', 3);
  // behindLight.position.set(0, 0, -20);

  // const ambientLight = new DirectionalLight(0xffffff, 1.25);
  const ambientLight = new AmbientLight(0xffffff, 0.6);

  const mainLight = new DirectionalLight(0xd4c3b0, 5);
  // mainLight.shadowDarkness = 0.5 * mainLight.intensity;
  mainLight.position.set(1, 1.5, 4);
  mainLight.castShadow = true;
  mainLight.shadow.bias = -0.0039;
  mainLight.shadow.radius = 1.6;
  mainLight.shadow.camera.top = 1;
  mainLight.shadow.camera.bottom = -1;
  mainLight.shadow.camera.left = -0.5;
  mainLight.shadow.camera.right = 0.5;
  mainLight.shadow.camera.near = 3;
  mainLight.shadow.camera.far = 8;
  console.log(mainLight)

  const pointLight_1 = new DirectionalLight(0xD4C2AF, 2.5, 1.34);
  pointLight_1.position.set(8.2, 14.2, -5.28);
  // pointLight_1.position.set(0.82, 1.42, -0.528);

  const pointLight_2 = new DirectionalLight(0x2A8BB7, 8, 1.64);
  pointLight_2.position.set(8.7, 4.5, 7.8);
  // pointLight_2.position.set(0.87, 0.45, 0.78);

  const pointLight_3 = new DirectionalLight(0xCABF83, 3, 1.94);
  pointLight_3.position.set(-7.16, 13.77, -5.6);
  // pointLight_3.position.set(-0.716, 1.377, -0.56);

  return { ambientLight, mainLight, pointLight_1, pointLight_2, pointLight_3 };
}

export { createLights };
